export default __webpack_public_path__ + "static/media/gallery-9.a745d03c.png";